import DOMPurify from 'dompurify';

export default {
  /**
   * href 防止 XSS 攻击
   * @param {*} userInput 
   * @returns 
   */
  sanitizeHref(userInput) {
    // 1. 首先使用 DOMPurify 进行初步净化
    const sanitizedUrl = DOMPurify.sanitize(userInput);
    
    // 2. 进一步验证协议是否在白名单内（https, http, mailto, tel）
    try {
      const parsedUrl = new URL(sanitizedUrl, window.location.origin); // 使用当前 origin 作为基础处理相对URL
      const allowedProtocols = ['https:', 'http:', 'mailto:', 'tel:'];
      if (allowedProtocols.includes(parsedUrl.protocol)) {
        return parsedUrl.toString(); // 返回安全的绝对URL
      } else {
        // 如果协议不在白名单内，返回一个空字符串或安全的占位符，避免使用危险URL
        console.warn('Unsafe URL protocol detected:', parsedUrl.protocol);
        return '#'; // 或者 return '';
      }
    } catch (error) {
      // 如果 URL 解析失败，也返回一个安全的值
      console.error('Invalid URL:', error);
      return '#'; // 或者 return '';
    }
  }
}